export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
export const SIGNUP = 'SIGNUP';
export const LOGINERROR = "LOGINERROR";
export const SIGNUPERROR = 'SIGNUPERROR';
export const ADDNOTE = 'ADDNOTE';
export const ADDNOTEERROR = 'ADDNOTEERROR';
export const DELETENOTE = 'DELETENOTE';
export const DELETENOTEERROR = 'DELETENOTEERROR';
export const UPDATENOTE = 'UPDATENOTE';
export const UPDATENOTEERROR = 'UPDATENOTEERROR';
export const GETNOTES = 'GETNOTES';
export const GETNOTESERROR = 'GETNOTESERROR';
export const CREATELABELS = 'CREATELABELS';
export const CREATELABELSERROR = 'CREATELABELSERROR';
export const GETLABELS = 'GETLABELS';
export const GETLABELSERROR = 'GETLABELSERROR';
export const DELETELABEL = 'DELETELABEL';
export const DELETELABELERROR = 'DELETELABELERROR';
export const UPDATELABELS = 'UPDATELABELS';
export const PUTARCHIVE = 'PUTARCHIVE';
export const GETARCHIVE = 'GETARCHIVE';
export const GETARCHIVEERROR = 'GETARCHIVEERROR';
export const DELETEARCHIVE = 'DELETEARCHIVE';
export const DELETED = 'DELETED';
export const DELETEDERROR = 'DELETEDERROR';
export const SETTINGS = 'SETTINGS';
export const RESTORE = "RESTORE";
